import React, { useEffect, useRef } from 'react';
import ApexCharts from 'apexcharts';

const MarketAreaChart = () => {
  const chartRef = useRef(null);

  useEffect(() => {
    let chart;
    
    if (chartRef.current) {
      const options = {
        chart: {
          height: 180,
          type: 'line',
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
        },
        series: [
          {
            color: '#30E7ED',
            data: [20, 40, 85, 25, 50, 30, 50,20,50,40,30,20],
          },
        ],
        xaxis: {
          categories: ['Ян', 'Фев', 'Мар', 'Апр', 'Май', 'Юни', 'Юли','Авг','Сеп','Окт','Ное','Дек'],
        },
      };

      chart = new ApexCharts(chartRef.current, options);
      chart.render();
    }

    return () => {
      if (chart) {
        chart.destroy();
      }
    };
  }, []);

  return <div id="market-area" ref={chartRef}></div>;
};

export default MarketAreaChart;
